import { FaDownload } from "react-icons/fa";
import ResumeViewer from "./ResumeViewer";

function Portfolio() {
  return (
    <div className="flex flex-col w-full pt-20 pb-16 bg-bg" id="resume">
      <div className="px-6 md:px-8 lg:px-16">
        <p className="eyebrow text-eyebrow">02 — Experience</p>
        <div className="flex flex-col gap-5 mt-3 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex-1 min-w-0 sm:pr-8">
            <h2 className="text-h2 text-heading">Experience</h2>
            <p className="mt-3 text-base text-muted sm:text-lead">
              Full-stack software engineer who builds web applications,
              AI-powered automation, and data-processing systems end to end —
              React / Next.js and TypeScript on the front end, Node.js on the
              back end. Recent work spans influencer-marketing growth systems at
              Bloom Nutrition, a college transfer-credit evaluation platform, a
              multi-marketplace commerce product (ryventory), and RAG-powered
              developer tooling built on n8n, Supabase, Redis, and the OpenAI
              SDK.
            </p>
          </div>
          <a
            href={`${process.env.PUBLIC_URL}/resume.pdf`}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent text-white font-semibold shadow-card transition-all hover:bg-accent-hover hover:shadow-card-hover active:translate-y-px shrink-0"
          >
            <FaDownload className="w-4 h-4" />
            Download résumé (PDF)
          </a>
        </div>
      </div>
      <ResumeViewer />
    </div>
  );
}

export default Portfolio;
